import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();
export const isPhoneValid = (nationalNumber: string, countryCode: string) => {
  try {
    return phoneUtil.isPossibleNumber(
      phoneUtil.parse("+" + countryCode + nationalNumber)
    );
  } catch (error) {
    return false;
  }
};
